import styled from 'styled-components';
import { Card } from '@amzn/storm-ui-v3';

const StyledCard = styled(Card)`
  margin-top: ${({ theme }) => theme.spacing.xlarge};
  margin-left: auto;
  margin-right: auto;
  width: auto;
  max-width: 960px;

  table {
    border: none;
  }

  tr {
    border: none;
  }

  table tbody tr th {
    max-width: 200px;
    text-align: right;
  }

  [role='rowheader'] {
    background-color: ${({ theme }) => theme.palette.white};
    border-style: none;
  }

  [role='cell'] {
    border-style: none;
  }
`;

export { StyledCard };
